import State from "@/helpers/pattern/state";
import { modelIsModified } from "@/helpers/vue-mc";
import { EventBus } from "@/events/event-bus";
import * as events from "@/constants/event-names";
import { clearSwal } from "@/constants/sweet-alerts";
import { scrollToForm } from "@/helpers/form-scroll-to";
import proveedorposAPI from "@/services/operativos/proveedorpos";
import CombosAPI from "@/services/catalogos";
import { ProveedorPos } from "@/models/operativos/proveedorPos";
import { setSelectsInactiveDataMultipleJson, getJson, setJson } from "@/helpers/form-common";
/**
 * State Pattern for proveedor pos form
 */
export default class ProveedorPosStates extends State {
  /**
   * General Methods
   */
  base() {
    return {
      clear({ $setState }) {
        $setState("initial");
      }
      , async askForClear({ $data }) {
        try {
          if ((await $data.$swal(clearSwal)).value) this.clear();
        } catch (error) {
          console.error(error);
        }
      }
      , resetModel({ $data }) {
        $data.proveedorpos = new ProveedorPos();
      }
      , resetValidators({ $data }) {
        $data.$v.$reset();
      }
      , isDisableButtonSubmit({ $data }) {
        return $data.hasErrors($data.$v.proveedorpos) || $data.view.action.submit.busy || !modelIsModified($data.proveedorpos);
      }
      , async loadSelectsData({ $data }) {
        const { data: { results: { combo: partnerList } } } = await CombosAPI.get({ option: "partner" });
        $data.view.elem.select.partners.filteredList = partnerList ? partnerList.filter((value) => value.status) : [];
        $data.view.elem.select.partners.completeList = partnerList || [];
      }
    };
  }

  /**
   * States and their methods
   */
  states() {
    return {
      initial: {
        $constructor: function ({ $data }) {
          // Reset Models and validators
          this.resetModel();
          this.loadSelectsData();
          this.resetValidators();

          // View configuration buttons
          $data.view.elem.button.submit.class.current = $data.view.elem.button.submit.class.save;
          $data.view.elem.button.submit.title.current = $data.view.elem.button.submit.title.save;
        }
        , async submit({ $data }, { descripcion, permitidos, partners, status }) {
          try {
            if (!$data.isAllValid($data.$v)) {
              EventBus.$emit(events.SHOW_TOASTER_MESSAGE, "error", "VL0000", $data.$t("errors.validof"));
              scrollToForm($data);
              return false;
            }

            $data.view.action.submit.busy = true;

            const response = await proveedorposAPI.save({
              clave: null
              , descripcion
              , permitidos
              , partners: setJson(partners)
              , status
            });

            $data.view.action.submit.busy = false;
            this.resetModel();
            this.resetValidators();
            $data.$refs.proveedorposTable.refreshData();
            return response;
          } catch (error) {
            console.error(error);
            $data.view.action.submit.busy = false;
            return error;
          }
        }
      }
      , editing: {
        $constructor: function ({ $data }, { clave, descripcion, permitidos, partners, status }) {
          // View configuration buttons
          $data.view.elem.button.submit.class.current = $data.view.elem.button.submit.class.update;
          $data.view.elem.button.submit.title.current = $data.view.elem.button.submit.title.update;

          // Set options to combos if not are active
          $data.view.elem.select.partners.filteredList = setSelectsInactiveDataMultipleJson(partners, $data.view.elem.select.partners.completeList);

          $data.proveedorpos = new ProveedorPos({
            clave
            , descripcion
            , permitidos
            , partners: getJson(partners)
            , status
          });

          this.resetValidators();
          scrollToForm($data);
        }
        , async submit({ $data, $setState }, { clave, descripcion, permitidos, partners, status }) {
          try {
            if (!$data.isAllValid($data.$v)) {
              EventBus.$emit(events.SHOW_TOASTER_MESSAGE, "error", "VL0000", $data.$t("errors.validof"));
              scrollToForm($data);
              return false;
            }
            $data.view.action.submit.busy = true;

            const response = await proveedorposAPI.update({
              clave
              , descripcion
              , permitidos
              , partners: setJson(partners)
              , status
            });

            $data.$refs.proveedorposTable.refreshData();
            $data.view.action.submit.busy = false;
            $setState("initial");
            return response;
          } catch (error) {
            console.error(error);
            $data.view.action.submit.busy = false;
            return error;
          }
        }
      }
    };
  }
}



// WEBPACK FOOTER //
// ./src/views/operativos/proveedorpos/proveedorpos-state.js